import React from "react";
import UserService from "services/UserService";

export function isArrayWithLength(arr) {
    return (Array.isArray(arr) && arr.length)
}

/**
 * une méthode utilitaire getAllowedRoutes dans laquelle nous pouvons
 * passer un tableau de routes et il retournera un tableau de routes filtrées
 * et passera ce tableau dans un composant de mappage de routes
 * **/

export function getAllowedRoutes(routes) {
    const permis = JSON.parse(localStorage.getItem('permission')) || [];
    const memv2versionactive = localStorage.getItem('memv2version');
    const currentusertype = localStorage.getItem('userType');
    const options = JSON.parse(localStorage.getItem('memoptions')) || [];
    // console.log(routes);
    let routesversion = routes.filter(({ memv2version }) => {
        if (memv2version <= memv2versionactive)
            return true;
    });
    // console.log(routesversion);
    routesversion = routesversion.filter(({ usertype, userdomain, name, option }) => {
        // console.log(name);
        // console.log(usertype && usertype==currentusertype);
        // console.log(option && options.find((x) => x.id === option));
        // console.log(userdomain && UserService.getEmail().endsWith('@'+userdomain));
        let allowed = false;
        if (!usertype && !userdomain && !option) //si aucun des trois filtres -> ok, sinon il faut avoir un des 3 de vrai
            allowed = true;
        else if (usertype && usertype == currentusertype)
            allowed = true;
        else if (option) {
            if (Array.isArray(option)) {
                option.forEach((opt) => {
                    if (options.find((x) => x.id === opt))
                        allowed = true;
                })
            }
            else if (options.find((x) => x.id === option))
                allowed = true;
        }
        if (!allowed && userdomain && UserService.getEmail().endsWith('@' + userdomain))
            allowed = true;
        return allowed;
    });
    // console.log(routesversion);
    return routesversion.filter(({ permission }) => {
        if (!permission) return true;
        else if (!isArrayWithLength(permission)) return true;
        else {

            return permission.every((perm) => 
            {
                if(isArrayWithLength(perm))
                {
                    return permis.some((x) => perm.includes(x));
                }
                else
                    return permis.includes(perm);
            });
        }
    });
}

